<template>
  <div class="row">
    <!-- Header -->
    <div class="col-12 mb-4">
      <div class="d-flex align-items-center justify-content-between flex-wrap">
        <div>
          <button @click="back" class="btn btn-sm btn-outline-secondary mb-2">
            <i class="mdi mdi-arrow-left mr-1"></i>{{ $t('common.back') }}
          </button>
          <h2 class="text-white font-weight-bold mb-1">{{ $t('superadmin.onboardNewCompany') }}</h2>
          <p class="text-muted small mb-0">{{ $t('superadmin.onboardSubtitle') }}</p>
        </div>
      </div>
    </div>

    <div class="col-12 grid-margin">
      <div class="card border-0 shadow-sm" style="background: #191c24; border-radius: 12px;">
        <div class="card-body p-4">
          <form class="forms-sample" @submit.prevent="submitForm" enctype="multipart/form-data">
            <!-- Section 1: Enterprise Profile -->
            <div class="d-flex align-items-center mb-3">
              <span class="badge badge-warning mr-2 px-2 py-1 font-weight-bold">1</span>
              <h5 class="text-white font-weight-bold mb-0">{{ $t('superadmin.companyInfo') }}</h5>
            </div>

            <div class="row mb-3">
              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="company-name">
                  {{ $t('superadmin.companyName') }} <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-domain"></i></span>
                  </div>
                  <input
                    type="text"
                    class="form-control bg-dark text-white border-secondary"
                    id="company-name"
                    v-model="ownerStore.companyName"
                    :placeholder="$currentLocale === 'id' ? 'Contoh: PT Sinergi Sukses Makmur' : 'e.g. PT Sinergi Sukses Makmur'"
                    required
                  />
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="owner-name">
                  {{ $t('superadmin.ownerName') }} <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-account-tie"></i></span>
                  </div>
                  <input
                    type="text"
                    class="form-control bg-dark text-white border-secondary"
                    id="owner-name"
                    v-model="ownerStore.ownerName"
                    :placeholder="$currentLocale === 'id' ? 'Contoh: Alex Pratama' : 'e.g. Alex Pratama'"
                    required
                  />
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="email-address">
                  {{ $t('superadmin.registeredEmail') }} <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-email-outline"></i></span>
                  </div>
                  <input
                    type="email"
                    class="form-control bg-dark text-white border-secondary"
                    id="email-address"
                    v-model="ownerStore.emailAddress"
                    :placeholder="$currentLocale === 'id' ? 'Contoh: owner@sinergi.co.id' : 'e.g. owner@sinergi.co.id'"
                    required
                  />
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="phone-number">
                  {{ $t('superadmin.phoneNumber') }}
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-phone"></i></span>
                  </div>
                  <input
                    type="tel"
                    class="form-control bg-dark text-white border-secondary"
                    id="phone-number"
                    v-model="ownerStore.phoneNumber"
                    :placeholder="$currentLocale === 'id' ? 'Contoh: 08123456789' : 'e.g. 08123456789'"
                  />
                </div>
              </div>
            </div>

            <!-- Section 2: Access & Credentials -->
            <div class="d-flex align-items-center mb-3">
              <span class="badge badge-warning mr-2 px-2 py-1 font-weight-bold">2</span>
              <h5 class="text-white font-weight-bold mb-0">{{ $t('superadmin.securityAndAllocation') }}</h5>
            </div>

            <div class="row mb-4">
              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="set-password">
                  {{ $t('superadmin.initialPassword') }} <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-lock-outline"></i></span>
                  </div>
                  <input
                    type="password"
                    class="form-control bg-dark text-white border-secondary"
                    id="set-password"
                    v-model="ownerStore.password"
                    :placeholder="$currentLocale === 'id' ? 'Minimal 6 karakter' : 'Min. 6 characters'"
                    required
                  />
                </div>
              </div>

              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="number-of-players">
                  {{ $t('superadmin.playerQuotaUsage') }} ({{ $t('quota.seats') }}) <span class="text-danger">*</span>
                </label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-dark border-secondary text-muted"><i class="mdi mdi-account-group"></i></span>
                  </div>
                  <input
                    type="number"
                    class="form-control bg-dark text-white border-secondary"
                    id="number-of-players"
                    v-model.number="ownerStore.numberOfPlayers"
                    placeholder="100"
                    min="1"
                    required
                  />
                </div>
              </div>
            </div>

            <!-- Section 3: Subscription & Billing Terms -->
            <div class="d-flex align-items-center mb-3">
              <span class="badge badge-warning mr-2 px-2 py-1 font-weight-bold">3</span>
              <h5 class="text-white font-weight-bold mb-0">{{ $t('superadmin.subscriptionTerms') }}</h5>
            </div>

            <div class="row mb-4">
              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="subscription">
                  {{ $t('superadmin.selectSubscriptionPlan') }} / {{ $currentLocale === 'id' ? 'Durasi' : 'Duration' }}
                </label>
                <select
                  class="form-control bg-dark text-white border-secondary"
                  id="subscription"
                  v-model="ownerStore.subscription"
                >
                  <option value="1 Month">{{ $currentLocale === 'id' ? '1 Bulan (Siklus Bulanan)' : '1 Month (Monthly Cycle)' }}</option>
                  <option value="3 Month">{{ $currentLocale === 'id' ? '3 Bulan (Kuartalan)' : '3 Months (Quarterly)' }}</option>
                  <option value="6 Month">{{ $currentLocale === 'id' ? '6 Bulan (Semester)' : '6 Months (Semi-Annual)' }}</option>
                  <option value="12 Month">{{ $currentLocale === 'id' ? '12 Bulan (Kontrak Tahunan)' : '12 Months (1 Year Enterprise Contract)' }}</option>
                </select>
              </div>

              <div class="col-md-6 mb-3">
                <label class="text-light small font-weight-bold" for="payment-status">
                  {{ $t('superadmin.initialPaymentStatus') }}
                </label>
                <select
                  class="form-control bg-dark text-white border-secondary"
                  id="payment-status"
                  v-model="ownerStore.paymentStatus"
                >
                  <option value="paid">{{ $t('superadmin.initialPaymentPaid') }}</option>
                  <option value="unpaid">{{ $t('superadmin.initialPaymentUnpaid') }}</option>
                </select>
              </div>
            </div>

            <!-- Section 4: Brand Logo -->
            <div class="d-flex align-items-center mb-3">
              <span class="badge badge-warning mr-2 px-2 py-1 font-weight-bold">4</span>
              <h5 class="text-white font-weight-bold mb-0">{{ $t('superadmin.companyLogo') }}</h5>
            </div>

            <div class="row mb-4">
              <div class="col-md-6">
                <div class="custom-file">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="company-logo"
                    @change="handleFileChange"
                    accept="image/*"
                  />
                  <label class="custom-file-label bg-dark text-muted border-secondary" for="company-logo">
                    {{ selectedFileName || $t('superadmin.chooseLogoFile') }}
                  </label>
                </div>
                <small class="text-muted mt-1 d-block">{{ $t('superadmin.logoRecommendation') }}</small>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="d-flex justify-content-end align-items-center pt-3 border-top border-secondary">
              <button
                type="button"
                @click="back"
                class="btn btn-outline-secondary px-4 py-2 mr-3"
                :disabled="loading"
              >
                {{ $t('common.cancel') }}
              </button>
              <button
                type="submit"
                class="btn btn-warning px-5 py-2 font-weight-bold text-dark"
                :disabled="loading"
              >
                <span v-if="loading" class="spinner-border spinner-border-sm mr-2" role="status"></span>
                <i v-else class="mdi mdi-check-circle-outline mr-1"></i>
                {{ loading ? $t('common.saving') : $t('superadmin.onboardClientBtn') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { storeOwner } from '@/services/ownerService';
import Swal from 'sweetalert2';

export default {
  name: 'CreateOwnerView',
  data() {
    return {
      ownerStore: {
        companyName: '',
        ownerName: '',
        emailAddress: '',
        phoneNumber: '',
        password: '',
        numberOfPlayers: 100,
        subscription: '1 Month',
        paymentStatus: 'paid',
        companyLogo: null,
      },
      selectedFileName: '',
      loading: false,
    };
  },
  methods: {
    handleFileChange(event) {
      if (event.target.files.length > 0) {
        this.ownerStore.companyLogo = event.target.files[0];
        this.selectedFileName = event.target.files[0].name;
      } else {
        this.ownerStore.companyLogo = null;
        this.selectedFileName = '';
      }
    },
    async submitForm() {
      this.loading = true;
      try {
        const payload = {
          ...this.ownerStore,
          company_name: this.ownerStore.companyName,
          name: this.ownerStore.companyName,
          owner_name: this.ownerStore.ownerName,
          email: this.ownerStore.emailAddress,
          email_address: this.ownerStore.emailAddress,
          phone_number: this.ownerStore.phoneNumber,
          number_of_players: this.ownerStore.numberOfPlayers,
          payment_status: this.ownerStore.paymentStatus,
          package_id: 1,
        };
        await storeOwner(payload);

        Swal.fire({
          icon: 'success',
          title: this.$t('common.success'),
          text: this.$currentLocale === 'id' ? 'Workspace perusahaan klien berhasil dibuat!' : 'Client enterprise workspace provisioned successfully!',
          confirmButtonColor: '#ffab00',
          background: '#12141c',
          color: '#fff',
        });

        this.$router.push({ name: 'ListOwner' });
      } catch (error) {
        const errors = error.response?.data?.errors;
        const errMsg =
          errors && typeof errors === 'object'
            ? Object.values(errors).flat()[0]
            : error.response?.data?.message || error.message || (this.$currentLocale === 'id' ? 'Gagal mendaftarkan perusahaan' : 'Failed to onboard company');

        Swal.fire({
          icon: 'error',
          title: this.$t('common.error'),
          text: errMsg,
          confirmButtonColor: '#ffab00',
          background: '#12141c',
          color: '#fff',
        });
      } finally {
        this.loading = false;
      }
    },
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
